<!--  Case Studies Hero Section  -->
<div class="annual-hero-bg">
  <section class="annual-hero-section container">
    <div class="glass-panel-container">
      <div class="row align-items-center">
        <div class="col-lg-5 hero-content-col">
          <!-- Title -->
          <h1 class="banner-heading-one">Hand-Picked <br>Case Studies</h1>
          <!-- Breadcrumbs -->
          <nav aria-label="breadcrumb" class="breadcrumb-nav">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a (click)="nav('/')">Home</a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">Case Studies</li>
            </ol>
          </nav>
        </div>
        <div class="col-lg-7 hero-image-col">
          <!-- Consistent Hero Image -->
          <img src="../../../../assets/resources/casestudies/casestudies-bannerimage.png" alt="Case Studies Illustration"
            class="hero-image">
        </div>
      </div>
    </div>
  </section>
</div>
<!-- Case Studies List & Filter Section -->
<div class="casestudies-list-section">
  <div class="container">
    <h2 class="section-title">Explore Our Case Studies</h2>

    <!-- Industry Filter Buttons -->
    <div class="filter-buttons-wrapper">
      <button class="filter-button" (click)="filterCards('All')"
        [class.active]="selectedIndustry === 'All'">All</button>
      <button class="filter-button" (click)="filterCards('Insurance')"
        [class.active]="selectedIndustry === 'Insurance'">Insurance</button>
      <button class="filter-button" (click)="filterCards('Finance')"
        [class.active]="selectedIndustry === 'Finance'">Finance</button>
      <button class="filter-button" (click)="filterCards('Healthcare')"
        [class.active]="selectedIndustry === 'Healthcare'">Healthcare</button>
      <button class="filter-button" (click)="filterCards('E-Commerce & Retail')"
        [class.active]="selectedIndustry === 'E-Commerce & Retail'">Ecom & Retail</button>
      <button class="filter-button" (click)="filterCards('Enterprise')"
        [class.active]="selectedIndustry === 'Enterprise'">Enterprise</button>
      <button class="filter-button" (click)="filterCards('Cloud')"
        [class.active]="selectedIndustry === 'Cloud'">Cloud</button>
      <button class="filter-button" (click)="filterCards('IT')" [class.active]="selectedIndustry === 'IT'">IT</button>
    </div>

    <!-- Case Study Cards Grid -->
    <div class="row g-4">
      <div class="col-lg-4 col-md-6" *ngFor="let item of filteredCards">
        <div class="casestudy-card h-100" (click)="nav(item.navLink)" data-aos="fade-up">
          <div class="card-image-wrapper">
            <img [src]="item.url" [alt]="item.description" class="card-image">
          </div>
          <div class="card-content">
            <h6 class="card-title">{{ item.description }}</h6>
            <div class="arrow-icon-wrapper">
              <i class="ri-arrow-right-line"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>